import React from 'react';
import { RouteComponentProps } from '@reach/router';
import { Breadcrumb, BreadcrumbItem } from 'react-magma-dom';
import { LessonsHeader, LessonsHeaderBlock } from '../Styled/StyledWrappers';
import { LessonsNavLinksData, LessonsLinkParamsData } from '../../pages/Lessons/config';

interface LessonsHeaderContainerProps extends RouteComponentProps {
  navLinks: LessonsNavLinksData[];
  params: LessonsLinkParamsData;
}

export const LessonsHeaderContainer: React.FC<LessonsHeaderContainerProps> = ({ navLinks, params }) => {
  return (
    <LessonsHeaderBlock>
      <LessonsHeader>
        <Breadcrumb tabIndex={-1} aria-label="">
          {navLinks.map((link, index) =>
            index + 1 != navLinks.length ? (
              <BreadcrumbItem
                tabIndex={-1}
                aria-label={link.name(params.names[index])}
                key={index}
                to={link.to(params)}
              >
                {link.name(params.names[index])}
              </BreadcrumbItem>
            ) : (
              <BreadcrumbItem tabIndex={-1} key={index}>
                {link.name(params.names[index])}
              </BreadcrumbItem>
            )
          )}
        </Breadcrumb>
      </LessonsHeader>
    </LessonsHeaderBlock>
  );
};
